<script>
  import { format } from 'svelte-i18n';

  import { SectionItem } from '@client/components/section';
  import { Select } from '@client/components/select';

  import { PUSH_ACTION_MODE } from '@client/enums';

  let actionOptions = [
    {
      label: $format('label.UPDATE'),
      value: 'update'
    },
    {
      label: $format('label.DELETE'),
      value: 'delete'
    }
  ];
  let modeOptions = Object.keys(PUSH_ACTION_MODE).map((key) => ({ label: $format(PUSH_ACTION_MODE[key]), value: key }));

  export let action = actionOptions[0];
  export let mode = modeOptions[0];
</script>

<SectionItem
  label={$format('label.PUSH_TYPE')}
  tooltip={$format('label.TOOLTIP.PUSH_TYPE')}
  description={$format('label.DESCRIPTION.PUSH_TYPE')}
>
  <Select
    bind:items={modeOptions}
    bind:value={mode}
    placeholder={$format('label.PLACEHOLDER.SELECT_MODE')}
    clearable={false}
    showChevron
  />
</SectionItem>

{#if mode?.value === 'signature' || mode?.value === 'banner'}
  <SectionItem
    label={$format('label.PUSH_ACTION')}
    tooltip={$format('label.TOOLTIP.PUSH_ACTION')}
    description={$format('label.DESCRIPTION.PUSH_ACTION')}
    data-testid="push-action"
  >
    <Select
      bind:items={actionOptions}
      bind:value={action}
      placeholder={$format('label.PLACEHOLDER.SELECT_PUSH_ACTION')}
      clearable={false}
      showChevron
    />
  </SectionItem>
{/if}
